module.exports = {"expire":"Current offers expire"}